import { render, staticRenderFns } from "./DuplicateButton.vue?vue&type=template&id=32d004b2&"
import script from "./DuplicateButton.vue?vue&type=script&lang=ts&"
export * from "./DuplicateButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports